import { axios } from './session'

export default class DustinService {
  static login = async () => {
    const response = await axios.get('/dustin/login');
    return response.data.url;
  }
}